import React from 'react'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { Input, InputGroup, InputGroupAddon } from 'reactstrap'

export const splitIdentification = (value, prefixes) => {
  const match = /^([A-Z])(\d*)$/.exec(value || '')
  return match && prefixes.includes(match[1])
    ? { prefix: match[1], number: match[2] }
    : { prefix: prefixes[0], number: '' }
}

const IdentificationInput = ({ value, onChange, prefixes, invalid, placeholder }) => {
  const { prefix, number } = splitIdentification(value, prefixes)

  return (
    <InputGroup>
      <InputGroupAddon addonType="prepend">
        <Input type="select" value={prefix} onChange={({ target }) => onChange(`${target.value}${number}`)}>
          {prefixes.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </Input>
      </InputGroupAddon>
      <NumberFormat
        className={classNames('form-control input-spin-none', { 'is-invalid': invalid })}
        value={number}
        placeholder={placeholder}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={0}
        allowNegative={false}
        isNumericString
        onValueChange={({ value: digits }) => onChange(`${prefix}${digits}`)}
      />
    </InputGroup>
  )
}

export default IdentificationInput
